"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupErrorCodes = exports.ProductType = exports.JobRole = void 0;
var JobRole;
(function (JobRole) {
    JobRole["UNSELECTED"] = "";
    JobRole["OTHER"] = "OTHER";
    JobRole["DEVELOPER"] = "DEVELOPER";
    JobRole["PRODUCT_MANAGER"] = "PRODUCT_MANAGER";
})(JobRole = exports.JobRole || (exports.JobRole = {}));
var ProductType;
(function (ProductType) {
    ProductType["UNSELECTED"] = "";
    ProductType["OTHER"] = "OTHER";
    ProductType["BENEFITS"] = "BENEFITS";
    ProductType["EMPLOYEE_ENGAGEMENT_AND_DEVELOPMENT"] = "EMPLOYEE_ENGAGEMENT_AND_DEVELOPMENT";
    ProductType["FINANCIAL_PLANNING"] = "FINANCIAL_PLANNING";
    ProductType["EXPENSE_MANAGEMENT"] = "EXPENSE_MANAGEMENT";
    ProductType["TAX_OPTIMIZATION"] = "TAX_OPTIMIZATION";
    ProductType["COMPLIANCE"] = "COMPLIANCE";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var SignupErrorCodes;
(function (SignupErrorCodes) {
    SignupErrorCodes["EMAIL_EXISTS"] = "email_exists";
    SignupErrorCodes["COMPANY_NAME_EXISTS"] = "company_name_exists";
})(SignupErrorCodes = exports.SignupErrorCodes || (exports.SignupErrorCodes = {}));
